<template>

    <div>

		<div v-for="(contents, index) in catalogContents" :key="contents" class="control" v-if="contents.category == categoryId">

            <div class="control">
                <textarea class="textarea is-medium" type="text" v-model="contents.content" :disabled="isDisabled"></textarea>
                <pop-confirm v-if="!isDisabled" content="Soll diese Textbox wirklich gelöscht werden?" icon="question-circle-o" cancel-text="abbrechen" :on-ok="function() { removeTextBox(index) }">
                    <button class="removeButton button is-small is-light" :title="$t('MSG-REMOVE_TEXT_BOX')"><span class="icon is-small"><i class="fa fa-trash"></i></span></button>
                </pop-confirm>
            </div>

	    </div>

    </div>

</template>




<script>
export default {

    data(){
		return {
			pageLayoutId: ''
		}
	},

    props: ['categoryId', 'catalogContents', 'value', 'isDisabled'],

    mounted() {

	},

    updated()  {

    },

    methods: {

  		addTextBox(catId) {

        if(this.newContentField.content != undefined && this.newContentField.content.length >= 3) {
            this.newContentField.category = catId;
            this.newContentField.siteCatalog = this.value.id;
            this.$emit('addTextBox', this.newContentField);
            this.newContentField = {};
        } else {
  				this.$notify.open({content: 'Bitte gib mindestens 3 Zeichen ein!', type: 'warning'});
  			}
      },

      removeTextBox(index) {

          this.$emit('removeTextBox', index);
          //this.$forceUpdate(); // force coputed property to update
      }
    },

}

</script>


<style>

    .expand-transition {
        transition: all .3s ease;
        height: 30px;
        padding: 10px;
        background-color: #eee;
        overflow: hidden;
    }

    .expand-enter, .expand-leave {
        height: 0;
        padding: 0 10px;
        opacity: 0;
    }
</style>


<style scoped>

    .control {
        position: relative;
    }

    .removeButton {
        position: absolute;
        right: -30px;
        top: 0;
    }
</style>
